module.exports = __webpack_public_path__ + "img/partners_cont02.effd1d10.jpg";